/* tslint:disable:max-line-length */
import classNames from 'classnames';
import React from 'react';
import { IconTypeProps } from '../types';

export const ConditionsIcon = ({
  className,
  style: styleFromProps,
  onClick,
  size,
  color = '#096DD9',
}: IconTypeProps) => {
  const style = {
    ...styleFromProps,
    ...(size ? { width: size, height: size } : {}),
  };
  return (
    <svg
      style={style}
      className={classNames(className)}
      onClick={onClick}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3 19.5C3 21.1547 4.34531 22.5 6 22.5C7.65469 22.5 9 21.1547 9 19.5C9 18.1219 8.0625 16.9594 6.79688 16.6078C7.1625 14.0953 9.65156 12.75 12 12.75C14.3484 12.75 16.8422 14.0953 17.2031 16.6078C15.9328 16.9594 15 18.1219 15 19.5C15 21.1547 16.3453 22.5 18 22.5C19.6547 22.5 21 21.1547 21 19.5C21 18.0938 20.025 16.9078 18.7172 16.5891C18.5531 15.0281 17.7891 13.7016 16.4953 12.7172C15.4547 11.9297 14.1234 11.4281 12.7547 11.2922V7.40625C14.0484 7.07344 15.0047 5.89688 15.0047 4.5C15.0047 2.84531 13.6594 1.5 12.0047 1.5C10.35 1.5 9.00469 2.84531 9.00469 4.5C9.00469 5.89688 9.96094 7.07344 11.2547 7.40625V11.2875C9.88594 11.4234 8.55 11.925 7.51406 12.7125C6.21562 13.6969 5.45625 15.0234 5.29219 16.5844C3.975 16.9078 3 18.0938 3 19.5ZM19.5 19.5C19.5 20.325 18.825 21 18 21C17.175 21 16.5 20.325 16.5 19.5C16.5 18.675 17.175 18 18 18C18.825 18 19.5 18.675 19.5 19.5ZM10.5 4.5C10.5 3.675 11.175 3 12 3C12.825 3 13.5 3.675 13.5 4.5C13.5 5.325 12.825 6 12 6C11.175 6 10.5 5.325 10.5 4.5ZM6 18C6.825 18 7.5 18.675 7.5 19.5C7.5 20.325 6.825 21 6 21C5.175 21 4.5 20.325 4.5 19.5C4.5 18.675 5.175 18 6 18Z"
        fill={color}
      />
    </svg>
  );
};
